export default __webpack_public_path__ + "node.js.d79662aa.png";